<div class="ml-1 mr-1">
  <select class="form-control border-0" [(ngModel)]="operation.operation">
    <option *ngFor="let op of operations" [ngValue]="op">{{op}}</option>
  </select>
</div>
